import { render, staticRenderFns } from "./Sign-up-success.vue?vue&type=template&id=43a5823e"
import script from "./Sign-up-success.vue?vue&type=script&lang=js"
export * from "./Sign-up-success.vue?vue&type=script&lang=js"
import style0 from "./Sign-up-success.vue?vue&type=style&index=0&id=43a5823e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports